import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import * as _ from "lodash";
import * as angular from "angular";
import { ProjectSharedDataService } from "../services/project-shared-data-service";
import { ProjectService } from "../services/project-service";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { AclService } from "../services/acl-service";
import { ContractService } from "../services/contract-service";
import { DocumentEntityService } from "../services/document-entity-service";
import { AdminService } from "../services/admin-service";
import { BaseEntityAssociationController } from "./rlAdmin.controllers";
import { EntityConfigService } from "../services/entity-config-service";
import { SearchService } from "../services/search-service";

export class ProjectSummaryController {

    static $inject = ["$scope", "$q", "$window", "projectService", "entityService", "notifyService", "projectSharedDataService", "eventService", "aclService"];

    projectID: string;                                                     // EntityID
    visibility: number;                                                     // visibility level of page
    sharedData: ProjectSharedDataService;
    locked: boolean;
    isValid: boolean;
    currencySymbol: string;
    charTypeName: string;
    listUrl: string;
    canEdit: boolean;
    selectedEntity: any;
    initialized: boolean;

    constructor(private $scope: ng.IScope,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private projectService: ProjectService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private projectSharedDataService: ProjectSharedDataService,
        private eventService: EventService,
        private aclService: AclService) {

        this.projectID = "";
        this.visibility = 1;
        this.sharedData = projectSharedDataService;
        this.locked = false;
        this.isValid = false;
        this.charTypeName = "";
        this.listUrl = "~/";
        this.canEdit = false;
        this.initialized = false;

        $scope.$watch(
            () => this.sharedData.projectStatus != null ? this.sharedData.projectStatus.lockIndicator : 1,
            (newvalue, oldvalue) => {
                this.locked = newvalue > 0;
            });

        $scope.$watch(
            () => {
                if (this.sharedData.project != null) {
                    return this.sharedData.project.charDataCollection.charDatas[Consts.TagLabels.Currency];
                } else {
                    return null;
                }
            },
            (newValue) => {
                if (newValue != null && newValue.length > 0) {
                    this.currencySymbol = newValue[0].value;
                } else {
                    this.currencySymbol = "";
                }
            }, true);

        $scope.$on(Consts.Events.ViewEntity, (e, data) => {
            if (!_.isEmpty(data)) {
                this.ViewEntity(data);
            }
        });
    }

    /*
     * Initialize controller
     * @param entityID entityID string of work order
     */
    Init(entityID: string, charTypeName: string, canEdit: string, listUrl: string) {
        this.projectID = entityID;

        var promise1 = this.sharedData.RefreshProject(this.projectID);
        var promise2 = this.sharedData.RefreshProjectStatus(this.projectID);

        this.$q.all([promise1, promise2])
            .then(() => {
                this.initialized = true;
            });

        if (!_.isEmpty(charTypeName)) {
            this.charTypeName = charTypeName;
        }
        if (!_.isEmpty(listUrl)) {
            this.listUrl = listUrl;
        }

        if (!_.isEmpty(canEdit)) {
            this.canEdit = canEdit.toLowerCase() == "true";
        }
        else {
            this.canEdit = false;
        }
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    /*
     * Refresh all sections of work order summary
     */
    RefreshAll(): ng.IPromise<any[]> {
        // start progress bar
        this.notifyService.startProgress();

        return this.sharedData.RefreshProjectStatus(this.projectID)
            .then(() => {
                var promises: ng.IPromise<any>[] = [];
                promises.push(this.RefreshValidation());
                promises.push(this.eventService.call(Consts.Events.ProjectRefreshAll));
                return this.$q.all(promises)
                    .finally(() => {
                        this.notifyService.endProgress();
                    });
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
            this.notifyService.startProgress();
            this.projectService.deleteProject(this.projectID)
                .then(() => {
                    this.$window.location.assign(this.listUrl);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting " + this.charTypeName);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    ViewEntity(viewEntityID: string) {
        this.entityService.getEntity(viewEntityID)
            .then((res) => {
                this.selectedEntity = res;
            });
    }
}

export class ProjectDetailsController {
    static $inject = ["$scope", "$window", "projectService", "entityService", "notifyService", "projectSharedDataService", "eventService"];

    projectID: string;
    initialized: boolean;
    editMode: boolean;
    canEdit: boolean;
    visibility: number;
    sharedData: ProjectSharedDataService;
    locked: boolean;
    isValid: boolean;

    charTypeName: string;
    listUrl: string;

    constructor(private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private projectService: ProjectService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private projectSharedDataService: ProjectSharedDataService,
        private eventService: EventService) {

        this.projectID = "";
        this.initialized = false;
        this.editMode = false;
        this.canEdit = false;
        this.visibility = 1;
        this.sharedData = projectSharedDataService;
        this.locked = false;
        this.isValid = false;
        this.charTypeName = "";
        this.listUrl = "~/";

        $scope.$watch(
            () => this.sharedData.project != null ? this.sharedData.project.charDataCollection.status.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });

        $scope.$watch(
            () => this.sharedData.projectStatus != null ? this.sharedData.projectStatus.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            }, true);
    }

    Init(projectID: string, charTypeName: string, canEdit: string, listUrl: string) {
        this.projectID = projectID;
        this.RefreshDetails();
        this.RefreshInventory();
        this.sharedData.RefreshProjectStatus(this.projectID);

        if (!_.isEmpty(canEdit)) {
            this.canEdit = canEdit.toLowerCase() == "true";
        }
        else {
            this.canEdit = false;
        }

        if (!_.isEmpty(charTypeName)) {
            this.charTypeName = charTypeName;
        }
        if (!_.isEmpty(listUrl)) {
            this.listUrl = listUrl;
        }

    }

    RefreshAll(): ng.IPromise<any> {
        return this.sharedData.RefreshProjectStatus(this.projectID)
            .then(() => {
                return this.RefreshValidation();
            });
    }

    RefreshDetails(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.sharedData.RefreshProject(this.projectID)
            .then((result) => {
                this.initialized = true;
            }, () => {
                this.notifyService.notifyError("Project Not Found");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshInventory(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.sharedData.RefreshInventory(this.projectID)
            .then((result) => {
                this.initialized = true;
            }, () => {
                this.notifyService.notifyError("Project Not Found");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    Edit() {
        this.editMode = true;
    }

    Cancel() {
        this.notifyService.startProgress();
        this.entityService.getEntityCharData(this.sharedData.project.record.id)
            .then((result) => {
                this.sharedData.project.charDataCollection = result;
                this.editMode = false;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Save(isValid: boolean) {

        if (isValid) {
            this.notifyService.startProgress();
            this.entityService.saveCharData(this.sharedData.project.record.id, this.sharedData.project.charDataCollection.charDatas)
                .then(() => {
                    this.notifyService.notifySuccess("Save Successful");
                    return this.RefreshDetails();
                }, this.notifyService.errorResponseHandler)
                .then(() => {
                    this.editMode = false;
                    this.RefreshValidation();
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });

        }
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
            this.notifyService.startProgress();
            this.projectService.deleteProject(this.projectID)
                .then(() => {
                    this.$window.location.assign(this.listUrl);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting " + this.charTypeName);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.notifyService.broadcastDone();
        }
    }
}

export class ProjectInventoryController {
    static $inject = ["$scope", "$q", "$window", "projectService", "notifyService", "entityService", "projectSharedDataService", "eventService"];

    projectID: string;
    visibility: number;
    initialized: boolean;
    inventoryItems: Models.IEntityRelationshipPair[];
    selectedInventoryItems: Models.IEntityRelationshipPair[];
    sharedData: ProjectSharedDataService;
    locked: boolean;

    addInventoryModalOpen: boolean;
    inventoryTemplateGroupIDs: number[];

    selectedSearchAssetIDs: number[];
    selectedSearchAssets: { [key: number]: boolean };                       // dictionary of selected assets from asset search modal
    groupCollapsed: { [groupID: string]: boolean };

    constructor(private $scope: ng.IScope,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private projectService: ProjectService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private projectSharedDataService: ProjectSharedDataService,
        private eventService: EventService
    ) {

        this.projectID = "";
        this.visibility = 1;
        this.initialized = false;
        this.inventoryItems = [];
        this.selectedInventoryItems = [];
        this.sharedData = projectSharedDataService;
        this.locked = false;

        this.addInventoryModalOpen = false;
        this.inventoryTemplateGroupIDs = [Consts.TemplateGroupIDs.InventoryItemTemplateGroup];
        this.selectedSearchAssetIDs = [];
        this.selectedSearchAssets = {};
        this.groupCollapsed = {};

        $scope.$watch(() => this.selectedSearchAssets, (newValue: { [key: string]: boolean }) => {
            this.selectedSearchAssetIDs = _(newValue)
                .pairs()
                .filter((pair) => pair[1] == true)
                .map((pair) => _.parseInt(<string>pair[0]))
                .valueOf();
        }, true);

        // clear selected assets whenever asset search modal is closed
        $scope.$watch(() => this.addInventoryModalOpen, (newValue: boolean, oldValue: boolean) => {
            if (!newValue && oldValue) {
                this.selectedSearchAssets = {};
            }
        }, true);

        $scope.$watch(
            () => this.sharedData.projectStatus != null ? this.sharedData.projectStatus.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            }, true);


    }

    Init(projectID: string) {
        this.projectID = projectID;
        this.RefreshAll()
            .then(() => {
                this.initialized = true;
            });
    }
    RefreshProject(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.sharedData.RefreshProject(this.projectID)
            .then((result) => {
                this.initialized = true;
            }, () => {
                this.notifyService.notifyError("Project Not Found");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshAll(): ng.IPromise<any> {
        return this.$q.all([this.RefreshProject(), this.RefreshInventory(), this.RefreshProjectStatus()])
            .then(() => {
                return this.RefreshValidation();
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    //FilterInventoryItems() {
    //    _.forEach(wo.inventoryItems, (inv) => {
    //        var item = _.find(this.inventoryItems, (x) => { return x.record.recordID == inv.record.recordID; });
    //        if (!_.isNull(item)) {
    //            if (_.contains(this.inventoryItems, item)) {
    //                this.inventoryItems = _.without(this.inventoryItems, item);
    //            }
    //        }
    //    });
    //    this.initialized = true;
    //}

    RefreshInventory(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.projectService.getProjectInventory(this.projectID)
            .then((result) => {
                this.inventoryItems = result;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshProjectStatus(): ng.IPromise<any> {
        return this.sharedData.RefreshProjectStatus(this.projectID);
    }


    SearchInventory() {
        this.addInventoryModalOpen = true;
        this.notifyService.broadcastDone();
    }

    AddAssets() {
        // get selected ids
        var assetIDs = this.selectedSearchAssetIDs;
        if (assetIDs.length > 0) {
            // start progress bar
            this.notifyService.startProgress();

            // make rest call
            this.projectService.addProjectInventory(this.projectID, assetIDs)
                .then((result) => {
                    if (result.length > 0) {
                        // notify success
                        if (result.length == 1) {
                            this.notifyService.notifySuccess("Added 1 inventory item.");
                        } else {
                            this.notifyService.notifySuccess("Added " + result.length + " inventory items.");
                        }
                        // wait for assets refresh
                        return this.RefreshAll();
                    }
                }, (event) => {
                    // error handler
                    this.notifyService.notifyError("There was an error associating these inventory items");
                })
                .then(() => {
                    // close modal
                    this.addInventoryModalOpen = false;
                })
                .finally(() => {
                    // end progress bar
                    this.notifyService.endProgress();
                });
        } else {
            // notify no selected assets
            this.notifyService.notifyError("No inventory items were selected");
        }
    }

    RemoveInventory(inventory: Models.IEntityRelationshipPair) {
        if (this.$window.confirm("Are you sure?")) {
            // start progress bar
            this.notifyService.startProgress();

            // call web api to remove assets
            this.projectService.removeProjectInventory(this.projectID, inventory.relationship.relRecID)
                .then((result) => {
                    // notify success
                    this.notifyService.notifySuccess("Inventory Removed");
                    // wait for refresh of assets
                    return this.RefreshAll();
                })
                .finally(() => {
                    // end progress bar
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Project?") && this.$window.confirm("Are you REALLY SURE you want to delete this Project?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.projectID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ProjectListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Project");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }
    ToggleAddInventory() {
        this.addInventoryModalOpen = !this.addInventoryModalOpen;
    }

    ToggleOpen(groupID: string) {
        this.groupCollapsed[groupID] = !this.groupCollapsed[groupID];
    }

}


export class ProjectDocumentsController {
    static $inject = ["$scope", "$sce", "$q", "$window", "contractService",
        "documentEntityService", "notifyService", "projectSharedDataService", "eventService", "entityService",
        "adminService", "$interval", "aclService"];

    projectID: string;
    visibility: number;
    initialized: boolean;
    docsInitialized: boolean;
    locked: boolean;
    editDocumentID: string;
    canEdit: boolean;

    constructor(private $scope: ng.IScope,
        private $sce: ng.ISCEService,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        private contractService: ContractService,
        private documentEntityService: DocumentEntityService,
        private notifyService: NotifyService,
        private sharedData: ProjectSharedDataService,
        private eventService: EventService,
        private entityService: EntityService,
        private adminService: AdminService,
        private $interval: ng.IIntervalService,
        private aclService: AclService) {

        this.projectID = "";
        this.visibility = 1;
        this.initialized = false;
        this.docsInitialized = true;
        this.editDocumentID = null;
        this.locked = false;
        this.canEdit = false;

        $scope.$watch(
            () => this.sharedData.project != null ? this.sharedData.project.charDataCollection.status.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });

        $scope.$watch(() => {
            if (this.projectID == null) {
                return null;
            } else {
                return this.projectID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.UpdateRecordStatus();
                    });
                }
            });
    }

    Init(projectID: string) {
        this.projectID = projectID;

        this.aclService.loadActivityAcls()
            .then((acls) => {
                this.canEdit = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod16);
            });

        this.notifyService.startProgress();
        this.sharedData.RefreshProject(this.projectID)
            .then(() => {
                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Project?") && this.$window.confirm("Are you REALLY SURE you want to delete this Project?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.projectID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ProjectListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Project");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    RefreshAll(): ng.IPromise<any> {
        return this.RefreshValidation()
            .then(() => {
                this.docsInitialized = false;
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    UpdateRecordStatus() {
        this.entityService.getEntity(this.projectID)
            .then((result) => {
                if (result.charDataCollection != null) {
                    if (result.charDataCollection.status.lockIndicator == 0) {
                        this.locked = false;
                    }
                    else {
                        this.locked = true;
                    }
                }
            });
    }
}

export class ProjectEntityAssociationSearchController extends BaseEntityAssociationController {
    static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q",
        "eventService", "entityService", "entityConfigService", "adminService", "$interval", "searchService", "projectSharedDataService", "aclService"];

    //Search objects
    keywords: string;
    pages: { [key: number]: number };
    templates: { [key: string]: Models.IKeyValuePair<string, number>[] };
    sortDirs: { [key: number]: string };
    sortFields: { [key: number]: string };
    selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
    selectedTemplate: string;
    selectedStatus: string;
    searchStates: { [key: string]: Models.IAdvancedSearchModel };
    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];

    //Associations objects
    sharedData: ProjectSharedDataService;
    filterByEntityID: string;
    charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
    selectedRecords: any[];
    associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
    currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
    canCreate: boolean = false;
    canEdit: boolean = false;
    currentCharTypeName: string;
    refreshAssociationPanels: boolean;
    initialized: boolean;

    constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
        public notifyService: NotifyService, private $window: ng.IWindowService,
        public $q: ng.IQService,
        private eventService: EventService,
        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
        public adminService: AdminService,
        public $interval: ng.IIntervalService,
        private searchService: SearchService,
        private projectSharedDataService: ProjectSharedDataService,
        private aclService: AclService) {

        super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

        //Search objects
        this.keywords = "";
        this.pages = {};
        this.templates = {};
        this.sortDirs = {};
        this.sortFields = {};
        this.selectedCharType = null;
        this.selectedTemplate = null;
        this.searchStates = {};
        this.templateFacets = [];
        this.statusFacets = [];

        //Associations objects
        this.sharedData = projectSharedDataService;
        this.filterByEntityID = "";
        this.charTypesAndTemplateGroups = [];
        this.selectedRecords = [];
        this.locked = false;
        this.currentCharTypeAndTemplateGroup = { name: "", createName: "", charTypeID: 0, tgIDs: [], isParentChar: false };
        this.currentCharTypeName = "";
        this.refreshAssociationPanels = false;
        this.visibility = 1;
        this.initialized = false;

        $scope.$watch(() => this.sharedData.projectStatus != null ? this.sharedData.projectStatus.lockIndicator : 1,
            (newvalue, oldvalue) => {
                this.locked = newvalue > 0;
            });
    }

    CharTypeChanged() {
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    TemplateChanged() {
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    StatusChanged() {
        this.BuildSearchStates();
    }

    Init(filterByEntityID: string, charTypeName: string, charTypeID: string, templateID: string) {
        this.filterByEntityID = filterByEntityID;
        this.baseEntityID = filterByEntityID;
        this.currentCharTypeName = charTypeName;

        //Get ACLs for user
        this.entityService.getEntityRecord(filterByEntityID)
            .then((result) => {
                var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
                this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
                this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
            });

        this.LoadTemplateGroups();
        this.sharedData.RefreshProject(filterByEntityID);
        this.sharedData.RefreshProjectStatus(filterByEntityID)
            .then(() => {
                this.initialized = true;
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        this.refreshAssociationPanels = true;
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    LoadTemplateGroups() {
        this.notifyService.startProgress();

        //Hardcoded list of valid char types per Joe N.
        //16, 1, 17, 4, 15, and 7
        var validCharTypes = [16, 1, 4, 17, 15, 7];

        this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.project)
            .then((results) => {

                _.forEach(results, (result) => {
                    var charName = result.charTypeName;

                    if (charName == "Transaction") {
                        charName = "Deals";
                    }
                    else if (charName == "Work Orders") {
                        charName = "Jobs";
                    }
                    else if (charName == "Property") {
                        charName = "Catalog Items";
                    }
                    else if (charName == "Invoice") {
                        charName = "Accounting";
                    }

                    if (validCharTypes.indexOf(result.charTypeID) > -1) {
                        this.charTypesAndTemplateGroups.push({
                            name: charName,
                            createName: charName,
                            charTypeID: result.charTypeID,
                            tgIDs: [1],
                            isParentChar: false
                        });

                        if (this.currentCharTypeName == charName) {
                            this.currentCharTypeAndTemplateGroup = {
                                name: charName,
                                createName: charName,
                                charTypeID: result.charTypeID,
                                tgIDs: [],
                                isParentChar: false
                            }
                        }
                    }
                });
            })
            .finally(() => {
                this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(Consts.CharTypeIDs.project)
                    .then((results) => {
                        _.forEach(results, (result) => {
                            var charName = result.charTypeName;

                            if (charName == "Transaction") {
                                charName = "Deals";
                            }
                            else if (charName == "Work Orders") {
                                charName = "Jobs";
                            }
                            else if (charName == "Property") {
                                charName = "Catalog Items";
                            }
                            else if (charName == "Invoice") {
                                charName = "Accounting";
                            }

                            var charType = { name: charName, createName: charName, charTypeID: result.charTypeID, tgIDs: [1], isParentChar: true }

                            //Check to see if the array already has reference to this charType.  If so, we just want to flip the isParentChar flag to true
                            //If not, add the new charType

                            var matchingCharTypes = this.charTypesAndTemplateGroups.filter(ct => ct.charTypeID == result.charTypeID);

                            if (validCharTypes.indexOf(result.charTypeID) > -1) {
                                if (matchingCharTypes.length > 0) {
                                    var index = this.charTypesAndTemplateGroups.indexOf(matchingCharTypes[0]);
                                    this.charTypesAndTemplateGroups[index].isParentChar = true;
                                }
                                else {
                                    this.charTypesAndTemplateGroups.push(charType);
                                }

                                if (this.currentCharTypeName == charName) {
                                    this.currentCharTypeAndTemplateGroup = {
                                        name: charName,
                                        createName: charName,
                                        charTypeID: result.charTypeID,
                                        tgIDs: [],
                                        isParentChar: true
                                    }
                                }
                            }
                        });
                    })
                    .finally(() => {
                        //Sort the list based on how Joe wants it
                        //Projects, Catalog Items, Deals, Inventory, Jobs, Accounting
                        var sortList = [16, 1, 4, 17, 15, 7];

                        var sorted = _.sortBy(this.charTypesAndTemplateGroups, function (obj) {
                            return _.indexOf(sortList, obj.charTypeID);
                        });

                        var currentCharTypeIndex = _.findIndex(sorted, c => c.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID);

                        this.SortByIndex(sorted, currentCharTypeIndex, 0);

                        this.charTypesAndTemplateGroups = sorted;

                        this.BuildSearchStates();
                        this.notifyService.endProgress();
                    });
            });
    }

    SortByIndex(collection: any[], fromIndex: number, toIndex: number) {
        collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
    }

    SearchSubmit() {
        this.BuildSearchStates();
    }

    BuildSearchStates() {
        var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};
        this.searchStates = {};

        var selectedCharTypeID = null;

        if (this.selectedCharType != null) {
            selectedCharTypeID = this.selectedCharType.charTypeID;
        }

        //associations
        var metaDataSearchRequest: Models.IAdvancedSearchModel = {
            charTypeID: selectedCharTypeID,
            searchGroups: [],
            keywords: this.keywords,
            page: this.pages[selectedCharTypeID] || 1,
            rowCount: 10,
            templateGroupIDs: [1, 2],
            template: this.selectedTemplate,
            status: this.selectedStatus,
            sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
            sortField: this.sortFields[selectedCharTypeID] || "",
            relatedEntityID: this.filterByEntityID
        };

        this.searchService.advancedSearch(metaDataSearchRequest)
            .then((res) => {
                this.templateFacets = res.getTemplateFacets();
                this.statusFacets = res.getStatusFacets();
            })
        // end reflective association search

        if (this.selectedCharType != null) {
            var searchState: Models.IAdvancedSearchModel = {
                charTypeID: selectedCharTypeID,
                searchGroups: [],
                keywords: this.keywords,
                page: this.pages[selectedCharTypeID] || 1,
                rowCount: 10,
                templateGroupIDs: [1, 2],
                template: this.selectedTemplate,
                status: this.selectedStatus,
                sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
                sortField: this.sortFields[selectedCharTypeID] || "",
                relatedEntityID: this.filterByEntityID,
                explicitRelationshipsOnly: true
            };

            tempSearchStates[this.selectedCharType.name] = searchState;
        }
        else {
            _.each(this.charTypesAndTemplateGroups, ct => {
                var searchState: Models.IAdvancedSearchModel = {
                    charTypeID: ct.charTypeID,
                    searchGroups: [],
                    keywords: this.keywords,
                    page: this.pages[selectedCharTypeID] || 1,
                    rowCount: 10,
                    templateGroupIDs: [1, 2],
                    template: this.selectedTemplate,
                    status: this.selectedStatus,
                    sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
                    sortField: this.sortFields[selectedCharTypeID] || "",
                    relatedEntityID: this.filterByEntityID,
                    explicitRelationshipsOnly: true
                };

                tempSearchStates[ct.name] = searchState;
            });
        }

		var keys = _.keys(tempSearchStates);
		keys.forEach(k => {
			var searchState = tempSearchStates[k];
			if (searchState.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID) {
				searchState.filterByEntityID = this.filterByEntityID;
				searchState.keywords = this.filterByEntityID;
				searchState.relatedEntityID = "";
			}
		});

        this.searchStates = tempSearchStates;
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    ClearSearch($event?: ng.IAngularEvent) {
        if ($event != null) {
            $event.preventDefault();
        }
        this.keywords = "";
        this.BuildSearchStates();
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Project?") && this.$window.confirm("Are you REALLY SURE you want to delete this Project?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.filterByEntityID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ProjectListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Project");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    ViewEntity(viewEntityID: string) {
        this.entityService.getEntity(viewEntityID)
            .then((res) => {
                this.selectedEntity = res;
            });
    }
}
